import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { Breakpoints } from '@/constants/enum/Breakpoints'

export const useScreenStore = defineStore('screen', () => {
  const windowWidth = ref(window.innerWidth)

  const isSmallMobile = computed(() => windowWidth.value < Breakpoints.MOBILE)
  const isMobile = computed(
    () => windowWidth.value >= Breakpoints.MOBILE && windowWidth.value < Breakpoints.TABLET,
  )
  const isTablet = computed(
    () => windowWidth.value >= Breakpoints.TABLET && windowWidth.value < Breakpoints.NOTEBOOK,
  )
  const isNotebook = computed(
    () => windowWidth.value >= Breakpoints.NOTEBOOK && windowWidth.value < Breakpoints.DESKTOP,
  )
  const isDesktop = computed(() => windowWidth.value >= Breakpoints.DESKTOP)

  return { windowWidth, isSmallMobile, isMobile, isTablet, isNotebook, isDesktop }
})
